import script from "./GlowRing.vue?vue&type=script&setup=true&lang=js"
export * from "./GlowRing.vue?vue&type=script&setup=true&lang=js"

import "./GlowRing.vue?vue&type=style&index=0&id=04165a77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04165a77"]])

export default __exports__